exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.swiper-pagination-bullet {\r\n  background: #fff;\r\n  width: 10px;\r\n  height: 10px;\r\n  display: inline-block;\r\n  border: solid 1px #000;\r\n  margin-right: 2px;\n}\n.swiper-container {\r\n  position: absolute;\r\n  overflow: hidden;\r\n  inset: 0;\n}\n.swiper-slide {\r\n  position: relative;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-39d68894","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./scripts/src/components/home-page-components/home-page-slider.component.vue
// module id = 594
// module chunks = 0